import { useEffect, useState } from "react";
import SbuxLoader from "../../components/SbuxLoader";
import { useAppDispatch, useAppSelector } from "../../store/types";
import InitCcp from "./components/InitCcp";
import { getCcpCredentials } from "../../services/ccp";
import { clearCcpCredentials } from "../../slices/ccpSlice";
import {
  getInstanceIdSelector,
  getInstanceUrlSelector,
} from "../../selectors/userInstanceSelector";
import {
  getCcpStatusSelector,
  getCcpInitializedSelector,
  getAccessTokenSelector,
  getAccessTokenExpirationSelector,
  getRefreshTokenSelector,
  getRefreshTokenExpirationSelector,
} from "../../selectors/ccpSelector";

const CCP = () => {
  const dispatch = useAppDispatch();
  const instanceId = useAppSelector(getInstanceIdSelector);
  const instanceUrl = useAppSelector(getInstanceUrlSelector);
  const status = useAppSelector(getCcpStatusSelector);
  const isCcpInitialized = useAppSelector(getCcpInitializedSelector);
  const AccessToken = useAppSelector(getAccessTokenSelector);
  const AccessTokenExpiration = useAppSelector(
    getAccessTokenExpirationSelector,
  );
  const RefreshToken = useAppSelector(getRefreshTokenSelector);
  const RefreshTokenExpiration = useAppSelector(
    getRefreshTokenExpirationSelector,
  );

  const [loginUrl, setLoginUrl] = useState<string | null>(null);
  const [ccpUrl, setCcpUrl] = useState<string | null>(null);

  useEffect(() => {
    instanceId && !isCcpInitialized && dispatch(getCcpCredentials(instanceId));
  }, [instanceId, isCcpInitialized]);

  useEffect(() => {
    if (AccessToken) {
      const actionUrl = `${instanceUrl}/auth/sign-in`;
      const tokenStr = String(AccessToken).trim();
      const tokenExpStr = String(AccessTokenExpiration).trim();
      const refreshStr = String(RefreshToken).trim();
      const refreshExpStr = String(RefreshTokenExpiration).trim();
      const loginFormUrl = `connect-login.html?accessToken=${tokenStr}&accessTokenExpiration=${tokenExpStr}&refreshToken=${refreshStr}&refreshTokenExpiration=${refreshExpStr}&actionUrl=${actionUrl.trim()}`;
      setLoginUrl(loginFormUrl);
      setCcpUrl(`${instanceUrl}/${process.env.REACT_APP_CONNECT_CCP_VERSION}`);
      dispatch(clearCcpCredentials());
    }
  }, [AccessToken]);

  return (
    <>
      {status !== "success" ? (
        <SbuxLoader />
      ) : (
        loginUrl && ccpUrl && <InitCcp ccpUrl={ccpUrl} loginUrl={loginUrl} />
      )}
    </>
  );
};

export default CCP;
